import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AppPage } from '@shared';
import axios from '@utils/axios-rails';

import OrdersListWithFilters from '@views/orders/components/OrdersListWithFilters';
import { pagyShape } from 'utils/shapes';

const propTypes = {
  orders: PropTypes.array,
  statuses: PropTypes.array.isRequired,
  couriers: PropTypes.array.isRequired,
  teams: PropTypes.array.isRequired,
  admin: PropTypes.bool.isRequired,
  initialFilters: PropTypes.object,
  pagy: pagyShape.isRequired,
  urlSubmitCSV: PropTypes.string,
  exportSubmitURL: PropTypes.string.isRequired,
}

const OrdersIndexAdmin = (props) => {
  return (
    <AppPage fullWidth>
      <OrdersListWithFilters
        orders={ props.orders }
        statuses={ props.statuses }
        couriers={ props.couriers }
        teams={ props.teams}
        admin={ props.admin}
        initialFilters={ props.initialFilters }
        pagy={ props.pagy }
        paginationClass={ props.paginationClass }
        exportSubmitURL={ props.exportSubmitURL }
      />
    </AppPage>
  );
}

OrdersIndexAdmin.propTypes = propTypes;

export default OrdersIndexAdmin;